<template>
  <div class="ui container">
    <h1 class="ui center aligned header">Scores Aanpassen:</h1>
    <div class="ui segment">
      <form class="ui huge form" @submit.prevent="updateScores">
        <div class="field" v-for="player in players" :key="player.id">
          <label>{{ player.name }}</label>
          <input type="number" v-model.number="scores[player.id]" />
        </div>
        <div class="ui fluid buttons">
          <div
            class="ui huge left labeled icon button"
            @click="$store.commit('TOGGLE_EDIT_SCORES_SCREEN')"
          >
            <i class="remove icon"></i> Annuleren
          </div>
          <button
            type="submit"
            class="ui orange huge right labeled icon button"
            :class="{ loading }"
          >
            <i class="check icon"></i> Klaar
          </button>
        </div>
      </form>
    </div>
    <transition name="fade" mode="out-in" :appear="true">
      <div class="ui negative message" v-if="error">
        <div class="header">Foutje!</div>
        <p>{{ error }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { map as _map } from 'lodash';

export default {
  name: 'edit-scores',
  data() {
    return {
      loading: false,
      error: null
    };
  },
  computed: {
    ...mapGetters(['players', 'nrOfPlayers']),
    scores() {
      return _map(this.players, 'score');
    }
  },
  methods: {
    updateScores() {
      let submitScores = true;
      this.loading = true;
      this.scores.forEach((score, playerId) => {
        if (score < 0) {
          submitScores = false;
          this.error = 'Score kan niet negatief zijn.';
        } else {
          this.$store.commit('CHANGE_SCORE_OF_PLAYER', { score, playerId });
        }
      });
      if (submitScores) {
        this.$store.dispatch('syncGame').then(() => {
          this.$store.commit('TOGGLE_EDIT_SCORES_SCREEN');
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.ui.header {
  font-size: 3rem;
  margin-bottom: 1em;
  margin-top: 0.5em;
}
.ui.form .field > label {
  font-size: 2rem;
  line-height: normal;
}
</style>
